import React from "react";

import "./BackGroundAlert.css";
import { GiArchiveResearch } from "react-icons/gi";
const BackGroundAlert = () => {
  return (
    <div className="box-alert-background">
      <div className="alert-background">
        <div className="box-icon-alert-background">
          <GiArchiveResearch className="icon-background-alert" />
        </div>
        <div className="box-text-alert-background">
          <p className="text-alert-background">
            Por favor, espere a que la alerta aparezca para buscar las tablas con la información adquirida.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BackGroundAlert;
